'use client';
import { createContext, useContext, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

// TODO: Mayve not keep null once I have a better understanding
const DataframeLayoutContext = createContext<any>({} as any);

export type DataframeLayoutSettings = {
  detailsPaneVisible?: boolean;
  openDetailsOnCellFocus?: boolean;
  schemaPaneVisible?: boolean;
  leftSidebarWidth?: string;
  rightSidebarWidth?: number;
};
export const DataframeLayoutContextProvider: React.FC<{
  children: React.ReactNode;
  settings?: DataframeLayoutSettings;
}> = ({ children, settings }) => {
  const [detailsPaneVisible, setDetailsPaneVisible] = useState(settings?.detailsPaneVisible ?? true);
  const [schemaPaneVisible, setSchemaPaneVisible] = useState(settings?.schemaPaneVisible ?? true);
  const [leftSidebarWidth, setLeftSidebarWidth] = useState(settings?.leftSidebarWidth ?? '20%');
  const [rightSidebarWidth, setRightSidebarWidth] = useState(settings?.rightSidebarWidth ?? 300);
  const [openDetailsOnCellFocus, setOpenDetailsOnCellFocus] = useState(settings?.openDetailsOnCellFocus ?? false);

  const onAllotmentChange = (allotment: any) => {
    setLeftSidebarWidth(allotment[0]);
    setRightSidebarWidth(allotment[2]);
  };

  // useHotkeys('ctrl+k', () => console.log('ctrl+k'));
  useHotkeys('meta+left', () => setSchemaPaneVisible(!schemaPaneVisible), { preventDefault: true });
  useHotkeys('meta+right', () => setDetailsPaneVisible(!detailsPaneVisible), { preventDefault: true });

  const value = {
    detailsPaneVisible,
    setDetailsPaneVisible,
    openDetailsOnCellFocus,
    setOpenDetailsOnCellFocus,
    schemaPaneVisible,
    setSchemaPaneVisible,
    leftSidebarWidth,
    setLeftSidebarWidth,
    rightSidebarWidth,
    setRightSidebarWidth,
    onAllotmentChange,
  };

  return <DataframeLayoutContext.Provider value={value}>{children}</DataframeLayoutContext.Provider>;
};

const useDataframeLayoutContext = () => {
  const {
    detailsPaneVisible,
    setDetailsPaneVisible,
    openDetailsOnCellFocus,
    setOpenDetailsOnCellFocus,
    schemaPaneVisible,
    setSchemaPaneVisible,
    leftSidebarWidth,
    setLeftSidebarWidth,
    rightSidebarWidth,
    setRightSidebarWidth,
    onAllotmentChange,
  } = useContext(DataframeLayoutContext);
  return {
    detailsPaneVisible,
    setDetailsPaneVisible,
    openDetailsOnCellFocus,
    setOpenDetailsOnCellFocus,
    schemaPaneVisible,
    setSchemaPaneVisible,
    leftSidebarWidth,
    setLeftSidebarWidth,
    rightSidebarWidth,
    setRightSidebarWidth,
    onAllotmentChange,
  };
};

export default useDataframeLayoutContext;
